module.exports = __webpack_public_path__ + "img/suzuki.71757a83.jpg";